<template>
  <sidebar-left>
    <slot slot="sidebar-left">
      <SideMenu :SideMenuLinks="sideMenuLinks"></SideMenu>
    </slot>
    <slot slot="main">
      <div class="u-max-700 u-center-block">
        <page-header>
          <slot slot="title">{{ $t('customer.account.invoices.title') }}</slot>
          <slot slot="description">
            <p >{{ $t('intro.customer_account_invoices') }}</p>
          </slot>
        </page-header>
        <div class="filters u-flex u-flex--column u-flex--align-items-center o-page-row">
          <v-input v-model="Name"
                   :placeholder="$t('customer.account.invoices.search_invoice')"
                   @blur="filterCustomerInvoices"
                   @enter="filterCustomerInvoices"
                   name="name"
                   type="search"
                   :fluid="true"
                   custom-class="u-padding u-fullwidth"
                   input-class="search">
          </v-input>
          <div class="u-flex u-flex--align-items-center line-top u-padding u-fullwidth">
            <v-input v-model="DateFrom"
                     @input="filterCustomerInvoices"
                     name="dateFrom"
                     type="date"
                     :horizontal="false"
                     custom-label-class="u-medium u-margin-bottom-small">
              <slot slot="label">{{ $t('customer.account.invoices.from_date') }}</slot>
            </v-input>
            <v-input v-model="DateTo"
                     @input="filterCustomerInvoices"
                     name="dateTo"
                     type="date"
                     :horizontal="false"
                     custom-label-class="u-medium u-margin-bottom-small">
              <slot slot="label">{{ $t('customer.account.invoices.to_date') }}</slot>
            </v-input>
            <div class="c-form-item u-fullwidth">
            <v-label id="totalAmount" for="totalAmount" class="u-medium u-margin-bottom">
              <slot name="label">{{ $t('customer.account.invoices.total_amount') }}</slot>
            </v-label>
            <vue-slider class="u-margin-bottom-medium u-pos-relative"
                        style="top: 3px"
                        v-model="TotalAmount"
                        width="100%"
                        name="totalAmount"
                        :height=2
                        :min=-10000
                        :max=20000
                        :dotSize="12"
                        tooltipPlacement="bottom"
                        :tooltip-formatter="v => `€ ${('' + v).replace(/^20000$/i, '+Ꝏ').replace(/^-10000$/i, '-Ꝏ')}`"
                        tooltip="always"
                        :enableCross=false
                        @drag-end="filterCustomerInvoices">
            </vue-slider>
              </div>
          </div>
        </div>

        <section :class="{ 'c-form-row o-page-bottom-spacing--medium u-center-block': true,'u-disabled': loadingInvoices }">
          <v-loading :data="loaded" custom-class="u-pos-relative"></v-loading>
          <table-component style="margin-bottom: 1em" table-class="c-table c-table--small" :data="CustomerInvoices.Invoices" :show-caption="false" :show-filter="false">
              <table-column header-class="header" cell-class="cell left u-text-align-left " :label="$t('customer.account.invoices.invoice_number')" :sortable="false">
                <template slot-scope="row"><button class="c-button c-button--white u-text-underline c-button--reset" @click.prevent='downloadItem(row.InvoiceNumber)'>{{ row.InvoiceNumber }}</button></template>
              </table-column>
              <table-column header-class="header" cell-class="cell" :label="$t('customer.account.invoices.invoice_date')" :sortable="false">
                <template slot-scope="row">{{ new Intl.DateTimeFormat($i18n.locale, { dateStyle: 'long' }).format(new Date(row.Date)) }}</template>
              </table-column>
              <table-column header-class="right header" cell-class="cell right" :label="$t('customer.account.invoices.invoice_amount')" :sortable="false">
                <template slot-scope="row">{{ row.TotalAmount | currency() }}</template>
              </table-column>
          </table-component>

          <v-pagination class="c-pager"
                        :config="PaginationConfig"
                        :pagination="PaginationData"
                        :pageInfo="false"
                        @paginated="fetchPaginated"
          ></v-pagination>
        </section>
      </div>
    </slot>
  </sidebar-left>
</template>

<script>

import PageHeader from '@/components/common/PageHeader'
import SideMenu from '@/components/common/SideMenu'
import SidebarLeft from '@/components/layout/SidebarLeft'
import VLoading from '@/components/Loading'
import VEmptyState from '@/components/EmptyState'
import VPagination from '@/components/Pagination'
import VInput from '@/components/form/Input'
import VueSlider from 'vue-slider-component'
import VLabel from '@/components/form/Label.vue'

import {mapGetters} from 'vuex'
import {config} from "../../../api/__http";
import axios from "axios";

export default {
  components: {
    PageHeader,
    SideMenu,
    SidebarLeft,
    VLoading,
    VEmptyState,
    VPagination,
    VInput,
    VueSlider,
    VLabel,
  },
  data() {
    return {
      Page: 1,
      loadingInvoices: false,
      Name: this.$route.query.name,
      DateFrom: this.$route.query.dateFrom,
      DateTo: this.$route.query.dateTo,
      TotalAmount: [this.$route.query.totalAmountFrom, this.$route.query.totalAmountTo],
      loaded: {}
    }
  },
  created(){
    if (!this.$route.query.totalAmountFrom && !this.$route.query.totalAmountTo) {
      this.TotalAmount[0] = -10000;
      this.TotalAmount[1] = 20000;
    }

    this.fetchCustomerInvoices();
  },
  computed: {
    ...mapGetters({
      CustomerInvoices: 'customerInvoices'
    }),
    PaginationConfig() {
      return {
        Page: this.Page
      }
    },
    PaginationData() {
      return {
        PageLastIndex: this.CustomerInvoices.PageLastIndex,
        Pages: this.CustomerInvoices.Pages,
      }
    },
    sideMenuLinks() {
      let menu = [
        {
          title: 'customer.account.edit.title',
          route: '/customer/account/edit',
        }
      ];

      if(this.isCustomer) {
        menu.push({
          title: 'customer.account.users.title',
          route: '/customer/account/users'
        });
        menu.push({
          title: 'customer.account.addresses.title',
          route: '/customer/account/addresses'
        });
      }

      if(this.isCustomer || this.isMarketing) {
        menu.push({
          title: 'customer.account.history.title',
          route: '/customer/account/history'
        });

        menu.push({
          title: 'customer.account.backorders.title',
          route: '/customer/account/backorders'
        })
      }

      if(this.isCustomer) {
        menu.push({
          title: 'customer.account.invoices.title',
          route: '/customer/account/invoices'
        });
      }

      return menu;
    },
    isCustomer() {
      return this.$store.getters.isCustomer;
    },
    isPersoneel() {
      return this.$store.getters.isPersoneel;
    },
    isMarketing() {
      return this.$store.getters.isMarketing;
    }
  },
  methods: {
    downloadItem (name) {
      document.body.style.cursor = 'progress';
      axios({
        url: config.baseUrl() + '/Customer/Invoice/' + name,
        method: 'GET',
        responseType: 'blob',

      }).then((response) => {
        const url = window.URL.createObjectURL( new Blob([response.data],{ type: "application/pdf" }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name + '.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        document.body.style.cursor = 'auto';
      });
    },
    fetchPaginated(config) {
      this.Page = config.Page;
      this.fetchCustomerInvoices();
    },
    filterCustomerInvoices() {
      let query = {};
      if (this.Name) {
        query['name'] = this.Name;
      }
      if (this.DateFrom) {
        query['dateFrom'] = this.DateFrom;
      }
      if (this.DateTo) {
        query['dateTo'] = this.DateTo;
      }
      if (!this.DateTo && this.DateFrom) {
        let date = new Date();
        this.DateTo = date.toISOString().split('T')[0];
      }
      if (this.DateTo && !this.DateFrom) {
        this.DateFrom = '2017-01-01';
      }
      if (this.TotalAmount[0]) {
        query['totalAmountFrom'] = this.TotalAmount[0];
      }
      if (this.TotalAmount[1]) {
        query['totalAmountTo'] = this.TotalAmount[1];
      }

      this.$router.push({ path: this.$route.path, query: query })
      this.Page = 1;
      this.fetchCustomerInvoices();
    },
    fetchCustomerInvoices() {
      this.loadingInvoices = true;
      this.loaded = {};

      this.$store.dispatch('getCustomerInvoices', {
          page: this.Page,
          name: this.Name ? this.Name : null,
          dateFrom: this.DateFrom ? this.DateFrom : null,
          dateTo: this.DateTo ? this.DateTo : null,
          totalAmountFrom:  this.TotalAmount[0] !== -10000 ? this.TotalAmount[0] : -9999999,
          totalAmountTo:  this.TotalAmount[1] !== 20000 ? this.TotalAmount[1] : 9999999,
      }).then(() => {
        this.loaded = { isLoaded: true }
        this.loadingInvoices = false;
      }).catch((e) => {
        this.loadingInvoices = false;
        this.loaded = { isLoaded: true }
        this.$notify({
          group: 'global',
          title: e.Message,
          text: this.$t('global.error_occured'),
          type: 'error',
          duration: 4000
        });
      })
    },
  }
}
</script>

<style lang="scss">
  @import "~@/assets/scss/private";

  $themeColor: $color-alpha;
  $bgColor: $color-disabled;
  $dotShadow: none;
  $dotBgColor: $color-alpha;
  $dotShadowFocus: 0 0 0 1px $color-alpha;
  $tooltipColor: $color-base;
  $tooltipBgColor: $color-white;
  $tooltipArrow: 0;
  $tooltipFontSize: 16px;
  $railBorderRadius: 0;

  @import '~vue-slider-component/lib/theme/default.scss';

  .header {
    font-weight: 600 !important;
  }

  .cell {
    background-color: $color-white !important;
  }

  .left {
    width: 25%;
    white-space: nowrap
  }

  .right {
    text-align: right !important;
  }

  .filters {
    background-color: $color-white !important;
    border: 1px solid rgba(41, 41, 41, 0.1);
  }

  .line-top {
    border-top: 1px solid rgba(41, 41, 41, 0.1);
    gap: em($global-spacing-unit-small);
  }

  .search {
    border-radius: 9999px;
    background-color: #F4F5F6 !important;
    box-shadow: none !important;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23000000' fill-rule='evenodd' d='M6.55417831 2.31331084 C8.91022651 2.31331084 10.7951422 4.19822651 10.7951422 6.5542747 C10.7951422 8.91013012 8.91022651 10.7952386 6.55417831 10.7952386 C4.19832289 10.7952386 2.31321446 8.91013012 2.31321446 6.5542747 C2.31321446 4.19822651 4.19832289 2.31331084 6.55417831 2.31331084 M6.55417831 5.78313253e-05 C2.94800964 5.78313253e-05 -3.85542169e-05 2.94810602 -3.85542169e-05 6.5542747 C-3.85542169e-05 10.1604434 2.94800964 13.1084916 6.55417831 13.1084916 C7.94309398 13.1084916 9.23234699 12.6714795 10.295094 11.9277687 L13.8312867 15.4699373 C14.2829494 15.9216 15.0181783 15.9216 15.469841 15.4699373 C15.9216964 15.0182747 15.9216964 14.2830458 15.469841 13.8313831 L11.9276723 10.2951904 C12.6713831 9.23244337 13.1083952 7.94319036 13.1083952 6.5542747 C13.1083952 2.94810602 10.160347 5.78313253e-05 6.55417831 5.78313253e-05'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 24px 50%;
    padding-left: 64px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/customer/account/Invoices.vue